module.exports = __webpack_public_path__ + "static/media/btn-remove-photo.4a182d4c.svg";